module.exports = __webpack_public_path__ + "media/images/lb/210-3f82c11c9ab81c148d8e03b766654626.svg";